import { useState } from "react";
import heroBg from "../../../assets/team.jpg";
import RegisterModal from "../../platform_core/auth/components/RegisterModal";
import "./Home.scss";

export default function Module() {
  const [isRegisterOpen, setIsRegisterOpen] = useState(false);

  return (
    <>
      <section
        className="module"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="module__overlay" aria-hidden="true" />
        <div className="module__hero">
          <h1 className="module__hero-title">
            Sie brauchen nicht alles was wir haben, aber wir haben alles was Sie
            brauchen.
          </h1>
          <p className="module__hero-subtitle">
            Vereinen Sie Margenkalkulation, CRM und Cockpit auf einer Plattform –
            für schnelle, messbare Ergebnisse.
          </p>
          <div className="module__hero-actions">
            <button type="button" className="module__hero-btn module__hero-btn--primary">
              Demo anfordern
            </button>
            <button
              type="button"
              className="module__hero-btn module__hero-btn--secondary"
              onClick={() => setIsRegisterOpen(true)}
            >
              Jetzt kostenlos loslegen
            </button>
          </div>
        </div>
      </section>

      <RegisterModal
        isOpen={isRegisterOpen}
        onClose={() => setIsRegisterOpen(false)}
      />
    </>
  );
}
